import { render, staticRenderFns } from "./ServiceStatusCard.vue?vue&type=template&id=06f20988&scoped=true"
import script from "./ServiceStatusCard.vue?vue&type=script&lang=ts"
export * from "./ServiceStatusCard.vue?vue&type=script&lang=ts"
import style0 from "./ServiceStatusCard.vue?vue&type=style&index=0&id=06f20988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f20988",
  null
  
)

export default component.exports